export default __webpack_public_path__ + "static/media/Slider-1.b660bb60.png";